import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Chip from "@material-ui/core/Chip";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import MenuIcon from "@material-ui/icons/Menu";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import AccountCircle from "@material-ui/icons/AccountCircle";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import EmailIcon from "@material-ui/icons/Email";
import MoreIcon from "@material-ui/icons/MoreVert";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from "@material-ui/core/LinearProgress";
import { loadCSS } from "fg-loadcss/src/loadCSS";
import EmailTestModal from "../Email/EmailTestModal";
import { HINAN_KUNREN_COMMON_ACCESS_KEY } from "../../config/HinanKunrenConfig";

const providerAccessKeyMap = {
  DEA: "dea",
  TEPCO: "td94cq1n92ivx6q7hpu3uxvn",
  "NTT ME": "qf70ypdjdzm89ypqvc4r7nf9",
  "NTT-FT": "z7n3q9m1x4p2v0ydk8twr5fb",
  "ほくでん": "lqdp4c7fuwgfz89og7q4x9f3",
  "汎用事業者": HINAN_KUNREN_COMMON_ACCESS_KEY,
};

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: theme.spacing(0.2),
    marginRight: theme.spacing(1),
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
      marginRight: theme.spacing(2),
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  appBar: {
    boxShadow: "none",
    position: "relative",
    zIndex: theme.zIndex.drawer + 100,
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
    },
    backgroundColor: "#fff",
    borderBottomWidth: "1px",
    borderBottom: "solid #d4d4d4",
  },
  toolBar: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(2),
  },
  logo: {
    marginTop: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      maxWidth: "180px",
    },
  },
  a: {
    marginRight: theme.spacing(2),
    fontSize: 15,
    color: "#000",
  },
  emailText: {
    marginTop: theme.spacing(1.5),
    marginLeft: theme.spacing(1.5),
    fontSize: 15,
    color: "#000",
  },
  providerChip: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
    height: 24,
    "& .MuiChip-label": {
      display: "flex",
      alignItems: "center",
      height: "100%",
      lineHeight: 1.2,
    },
  },
  nestedMenuItem: {
    paddingLeft: theme.spacing(4),
  },
}));

const Header = ({ logo, logoAltText, toggleDrawer, handleLogout, currentPage, pageTopLoader, totalAssetStats }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [email, setEmail] = useState("");
  const [isDeaAdmin, setIsDeaAdmin] = useState(false);
  const [currentProvider, setCurrentProvider] = useState("");
  const [isProviderMenuOpen, setIsProviderMenuOpen] = useState(false);
  const [isMobileProviderMenuOpen, setIsMobileProviderMenuOpen] = useState(false);
  const [isEmailTestModalOpen, setIsEmailTestModalOpen] = useState(false);

  const providerOptions = Object.keys(providerAccessKeyMap);

  useEffect(() => {
    loadCSS(
      "https://use.fontawesome.com/releases/v5.12.0/css/all.css",
      document.querySelector("#font-awesome-css")
    );
    try {
      const storedEmail = localStorage.getItem("email");
      if (storedEmail) {
        setEmail(storedEmail);
      }
      setIsDeaAdmin(localStorage.getItem("dea_role") === "admin");
      const currentAccessKey = localStorage.getItem("access_key");
      const normalizedAccessKey =
        currentAccessKey && currentAccessKey !== "undefined" && currentAccessKey !== "null"
          ? currentAccessKey
          : "";
      const providerName = Object.keys(providerAccessKeyMap).find(
        (provider) => providerAccessKeyMap[provider] === normalizedAccessKey
      );
      setCurrentProvider(providerName || "TEPCO");
    } catch (e) {
      console.warn("Unable to access localStorage:", e);
    }
  }, []);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
    setIsMobileProviderMenuOpen(false);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setIsProviderMenuOpen(false);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleProviderSelect = (provider) => {
    const selectedAccessKey = providerAccessKeyMap[provider];
    if (!selectedAccessKey) {
      return;
    }
    localStorage.setItem("access_key", selectedAccessKey);
    localStorage.setItem("admin_switched_access_key", selectedAccessKey);
    setAnchorEl(null);
    setMobileMoreAnchorEl(null);
    setIsProviderMenuOpen(false);
    setIsMobileProviderMenuOpen(false);
    if (provider === "DEA") {
      window.location.href = "/plot";
      return;
    }
    if (selectedAccessKey === HINAN_KUNREN_COMMON_ACCESS_KEY) {
      window.location.href = "/report";
      return;
    }
    if (currentPath === "/plot" && provider !== "DEA") {
      window.location.href = "/home";
      return;
    }
    window.location.reload();
  };

  const handleEmailTestMenuClick = () => {
    handleMenuClose();
    setIsEmailTestModalOpen(true);
  };

  const handleMobileEmailTestMenuClick = () => {
    handleMobileMenuClose();
    setIsEmailTestModalOpen(true);
  };

  const menuId = "primary-search-account-menu";
  const currentPath = window.location.pathname;
  const isViewerDetailPage =
    currentPath.includes("/viewer/") || currentPath.includes("/report-viewer/") || currentPath.includes("/plot-viewer/");
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {isDeaAdmin && [
        <MenuItem
          key="provider-switch-toggle"
          onClick={() => setIsProviderMenuOpen((prev) => !prev)}
        >
          <ListItemText primary="事業者切り替え" />
          {isProviderMenuOpen ? <ExpandLess /> : <ExpandMore />}
        </MenuItem>,
        <Collapse key="provider-switch-list" in={isProviderMenuOpen} timeout="auto" unmountOnExit>
          {providerOptions.map((provider) => (
            <MenuItem
              key={provider}
              className={classes.nestedMenuItem}
              onClick={() => handleProviderSelect(provider)}
            >
              <ListItemText primary={provider} />
            </MenuItem>
          ))}
        </Collapse>,
        <MenuItem key="email-test" onClick={handleEmailTestMenuClick}>
          <ListItemIcon>
            <EmailIcon />
          </ListItemIcon>
          <ListItemText primary="メール送信テスト" />
        </MenuItem>,
      ]}
      <MenuItem onClick={handleLogout}>
        <ListItemIcon>
          <ExitToAppIcon />
        </ListItemIcon>
        <ListItemText primary="ログアウト" />
      </MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {email && (
        <MenuItem disabled>
          <ListItemText primary={email} />
        </MenuItem>
      )}
      {isDeaAdmin && [
        <MenuItem
          key="mobile-provider-switch-toggle"
          onClick={() => setIsMobileProviderMenuOpen((prev) => !prev)}
        >
          <ListItemText primary="事業者切り替え" />
          {isMobileProviderMenuOpen ? <ExpandLess /> : <ExpandMore />}
        </MenuItem>,
        <Collapse
          key="mobile-provider-switch-list"
          in={isMobileProviderMenuOpen}
          timeout="auto"
          unmountOnExit
        >
          {providerOptions.map((provider) => (
            <MenuItem
              key={`mobile-${provider}`}
              className={classes.nestedMenuItem}
              onClick={() => handleProviderSelect(provider)}
            >
              <ListItemText primary={provider} />
            </MenuItem>
          ))}
        </Collapse>,
        <MenuItem key="mobile-email-test" onClick={handleMobileEmailTestMenuClick}>
          <ListItemIcon>
            <EmailIcon />
          </ListItemIcon>
          <ListItemText primary="メール送信テスト" />
        </MenuItem>,
      ]}
      <MenuItem onClick={handleMobileMenuClose}>
        <ListItemIcon>
          <ExitToAppIcon />
        </ListItemIcon>
        <ListItemText primary="ログアウト" />
      </MenuItem>
    </Menu>
  );

  const handleClose = () => {
    window.close();
  };

  return (
    <div className={classes.grow}>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar className={classes.toolBar}>
          <IconButton
            className={classes.menuButton}
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer}
          >
            {!currentPage.includes("viewer") &&
              <MenuIcon />
            }
            {currentPage.includes("viewer")  &&
              <CloseIcon onClick={handleClose}  />
            }
          </IconButton>
          <Grid
            container
            spacing={1}
            alignItems="center"
          >
            <Grid item>
              <span className={classes.a}>
                <a href="/home">
                  <img src={logo} alt="logo" className={classes.logo} />
                </a>
              </span>
            </Grid>

            <Grid item xs />

            <Grid item>
              <div className={classes.sectionDesktop}>
                {isDeaAdmin && currentProvider && (
                  <Chip
                    className={classes.providerChip}
                    size="small"
                    label={`事業者：${currentProvider}`}
                  />
                )}
                {email && <span className={classes.emailText}>{email}</span>}
                {!isViewerDetailPage && (
                  <IconButton
                    edge="end"
                    aria-label="account of current user"
                    aria-controls="primary-search-account-menu"
                    aria-haspopup="true"
                    onClick={handleProfileMenuOpen}
                    color="inherit"
                  >
                    <AccountCircle />
                  </IconButton>
                )}
              </div>
              <div className={classes.sectionMobile}>
                {!isViewerDetailPage && (
                  <IconButton
                    aria-label="show more"
                    aria-controls="primary-search-account-menu-mobile"
                    aria-haspopup="true"
                    onClick={handleMobileMenuOpen}
                    color="inherit"
                  >
                    <MoreIcon />
                  </IconButton>
                )}
              </div>
            </Grid>
          </Grid>
        </Toolbar>
        {pageTopLoader ? <LinearProgress /> : null}
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
      <EmailTestModal
        open={isEmailTestModalOpen}
        onClose={() => setIsEmailTestModalOpen(false)}
      />
    </div>
  );
};

Header.prototypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  currentPage: state.app.currentPage,
  pageTopLoader: state.app.pageTopLoader,
  totalAssetStats: state.home.totalAssetStats,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(Header));
